import { isValid, parse } from 'date-fns';

import { DateOfBirthType } from 'src/components/date-of-birth-input/types';

export const convertToDate = (inputValue: DateOfBirthType): Date | null => {
    const { day, month, year } = inputValue;

    const dateString = `${day} ${month} ${year}`;
    const date = parse(dateString, 'd MMMM yyyy', new Date());

    if (!isValid(date)) {
        return null;
    }

    return date;
};
